module.exports = __webpack_public_path__ + "img/中国精神-企业家精神内容页.png";